<script>
	import { createEventDispatcher } from "svelte";
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";
	import CustomTextArea from "../../../components/CustomTextArea/CustomTextArea.svelte";

	export let isOpen = false;
	export let issues = [];

	const dispatch = createEventDispatcher();

	const notFixedReasonByIssueId = Object.fromEntries(
		issues.map((issue) => [issue.id, ""])
	);
	let showValidation = false;

	function back() {
		dispatch("back");
	}

	function confirm() {
		const missingReason = issues.some(
			(issue) => !notFixedReasonByIssueId[issue.id]?.trim()
		);
		if (missingReason) {
			showValidation = true;
			return;
		}

		dispatch("confirm", {
			notFixedReasonByIssueId: Object.fromEntries(
				issues.map((issue) => [
					issue.id,
					notFixedReasonByIssueId[issue.id].trim(),
				])
			),
		});
	}
</script>

<Modal {isOpen} toggle={back} centered>
	<ModalHeader toggle={back}>Complete work order</ModalHeader>
	<ModalBody>
		<p class="mb-3">
			Provide reason for not being able to resolve the following issue(s)
		</p>
		{#each issues as issue}
			<div class="mb-3">
				<p>{issue.serviceCategory} — {issue.issueType?.name}</p>
				<CustomTextArea
					bind:value={notFixedReasonByIssueId[issue.id]}
					maxlength={100}
					label={`${issue.code} — ${issue.issueDescription}`}
					placeholder="e.g. parts not in stock"
					error={showValidation &&
						!notFixedReasonByIssueId[issue.id]?.trim()}
					errorText="A reason is required."
				/>
			</div>
		{/each}
	</ModalBody>
	<ModalFooter>
		<Button class="themeButton backButton" on:click={back}>Back</Button>
		<Button class="themeButton primary" on:click={confirm}>Confirm</Button>
	</ModalFooter>
</Modal>
